import { render, staticRenderFns } from "./ShareWidget.vue?vue&type=template&id=af1a5f98&scoped=true&"
import script from "./ShareWidget.vue?vue&type=script&lang=js&"
export * from "./ShareWidget.vue?vue&type=script&lang=js&"
import style0 from "./ShareWidget.vue?vue&type=style&index=0&id=af1a5f98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1a5f98",
  null
  
)

export default component.exports